import PortfolioDataList from "../../Data/PortfolioDataList";

export const PortfolioDiscription = ({ portfolioId }) => {
  const portfolio = PortfolioDataList.find((item) => item.id === portfolioId);
  const detail = portfolio.portfolioDescription;
  if (!portfolio) {
    return <div className="font-primary">Portfolio not found</div>;
  }

  return (
    <div>
      <div>
        <h4 className="border-b-[2px] text-xl border-gray-300 mb-[10px] pb-[4.5px] text-gray-900 ">
          <span className="border-b-[2px] font-semibold border-blue-700 pb-[5px] font-primary">
            Project Description
          </span>
        </h4>
        <p className="mb-[30px] text-gray-900 text-base font-primary">
          {detail.ProjectDescription}
        </p>
        <p className="text-gray-900 text-base font-[600] mb-[30px] font-primary">
          {detail.keyfeatures}:
        </p>

        <ul className="mb-[30px]">
          <li className="mb-[5px] font-primary text-gray-900 text-base">
            <strong className="text-gray-900 font-primary font-[600] mb-[30px]">
              Property Management:
            </strong>
            {detail.TrailExploration}
          </li>
          <li className="mb-[5px] text-gray-900 text-base font-primary ">
            <strong className="text-gray-900 text-base font-[600] font-primary mb-[30px]">
              Lead and Contact Management:
            </strong>
            {detail.ReviewandFeedback}
          </li>
          <li className="mb-[5px] text-gray-900 text-base font-primary">
            <strong className="text-gray-900 text-base font-[600] font-primary mb-[30px]">
              Property Matching Feature:
            </strong>
            {detail.EventParticipation}
          </li>
          <li className="mb-[5px] text-gray-900 text-base font-primary ">
            <strong className="text-gray-900 text-base font-[600] font-primar mb-[30px]">
              List and Map Views:
            </strong>
            {detail.communityPage}
          </li>
          <li className="mb-[5px] text-gray-900 text-base font-primary">
            <strong className="text-gray-900 text-base font-[600] font-primary mb-[30px]">
              Advanced Search Filters:
            </strong>
            {detail.UserandHostProfiles}
          </li>
          <li className="mb-[5px] text-gray-900 text-base font-primary">
            <strong className="text-gray-900 text-base font-[600] font-primary mb-[30px]">
              Interactive Map:
            </strong>
            {detail.SocialInteraction}
          </li>
          <li className="mb-[5px] text-gray-900 text-base font-primary">
            <strong className="text-gray-900 text-base font-[600] font-primary mb-[30px]">
              User-Friendly Interface:
            </strong>
            {detail.describe}
          </li>
        </ul>

        <p className="mb-16 text-gray-900 text-base font-primary">
          This Website is an all-in-one solution for anyone involved in the
          property market. Whether you’re a buyer searching for your dream home,
          a seller looking to list your property, or a real estate professional
          managing multiple listings and clients, this platform provides the
          tools and features needed to succeed in the competitive real estate
          industry.
        </p>
      </div>
    </div>
  );
};
